import React, { useEffect, useState, useRef, useCallback } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import i18n from 'i18next';
import { useTranslation, Trans } from "react-i18next";
import { Tooltip, Collapse } from 'antd';
import ReactDOM from 'react-dom';

import FormHeader from "../components/form/FormHeader";
import FormTitle from "../components/form/FormTitle";
import FormText from "../components/form/FormText";
import FormRemark from "../components/form/FormRemark";
import Space from "../components/core/Space";
import Flex from "../components/core/Flex";
import ShadowBox from "../components/core/ShadowBox";
import FormButtonDanger from "../components/form/FormButtonDanger";
import FormButtonSecondary from "../components/form/FormButtonSecondary";
import useHomeStore from "../store/useHomeStore";
import useViewStore from "../store/useViewStore";
import useApplyNewStore from "../store/useApplyNewStore";
// import Footer from "../components/common/Footer";
// import BXHeader from "../components/core/BXHeader/pages/Layout/Header";
import { basename, isProduction } from "../setting";

// Added by BX Howard for Homepage header and footer
import "./index.less";
import "../components/core/BXHeader/assets/less/base.less"
import "../components/core/BXHeader/assets/less/ui.less";
import { FooterPlus, HeaderPlus, BackTop } from "iron-man";
import { getCurrentLang, isMobileAPP, isMobileAPPHiddenHeader } from "../components/core/BXHeader/config/commonUtil";
import {  headerTabs } from '../components/core/BXHeader/pages/learnPage/Layout/HeaderData/data';
import {
  headerTabs as headerTabsEN,
} from '../components/core/BXHeader/pages/learnPage/Layout/HeaderData/dataEN';
import urlConstantJs from '../components/core/BXHeader/config/ConstantConfig'
import Api from "../components/core/BXHeader/api/";
import { getLink } from "../components/core/BXHeader/pages/learnPage/Layout/utils";
import { useLocation } from 'react-router-dom';
import InformationIcon from "../components/core/InformationIcon";
import useWindowSize from '../hooks/useWindowSize'
import classNames from "classnames";

import Dialog from "../components/Dialog/index";
import { userInfoKey } from '../constant/index'
// import {PDFReader} from 'iron-man'
// Added by BX Howard for Homepage header and footer [End]
import PromotionRewards from '../components/apply/promotionRewards'
//import Breadcrumb from "../components/common/Breadcrumb";
//import BreadcrumbList from "../components/common/BreadcrumbList";
function PageHome() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isSubBarSticky, setIsSubBarSticky } = useHomeStore((state) => state);
  const { isPadView, isMobileView } = useViewStore((state) => state);
  const { setStep } = useApplyNewStore((state) => state);
  const [currentSection, setCurrentSection] = useState(null);
  const subNavBarRef = useRef(null);
  const section1Ref = useRef(null);
  const section2Ref = useRef(null);
  const section3Ref = useRef(null);
  const section5Ref = useRef(null);
  const section6Ref = useRef(null);
  const section7Ref = useRef(null);

  // Added by BX Howard for Homepage header and footer
  const location = useLocation();
  const [loginFlag, setLoginFlag] = useState(false);
  const [raw, setRaw] = useState(null);
  const [rawHeader, setRawHeader] = useState(null);

  const getUser = async () => {
    const sc = new URLSearchParams(location.search).get('sc') || 0;
    setCartNum(sc);
    const temp = await fetch(`${process.env.REACT_APP_TOKEN_API_BASE_URL}/Token/Status`, {
      method: 'GET',
    });
    const res = await temp?.json() || {};
    // const mockData = {
    //   isLogin: true,
    //   loginId: 'andyChen',
    // };
    // res.data = mockData;
    if (res?.data?.loginId) {
      setLoginFlag(res?.data?.isLogin);
      sessionStorage.setItem(userInfoKey, JSON.stringify(res?.data));
    }
  };

  const getHFMenu = async () => {
    const temp = await fetch(`${process.env.REACT_APP_TOKEN_API_BASE_URL}/en/common/footerclasstree`, {
      method: 'GET',
    });
    const footerRes = await temp?.json() || {};
    if (footerRes.Code === 0 && footerRes.Success === true) {
      setRaw(footerRes?.Data || []);
    }

   const tempHeader = await fetch(`${process.env.REACT_APP_TOKEN_API_BASE_URL}/en/common/headerclasstree`, {
      method: 'GET',
    });
     const headerRes = await tempHeader?.json() || {};
    if (headerRes.Code === 0 && headerRes.Success === true) {
      setRawHeader(headerRes?.Data || []);
    }
  };

  /** 切换语言 */
  const handleChangeLanguage = () => {
    let lang;
    const curWwwPath = window.location.href;
    if (curWwwPath.match(/\/ch\b|\/ch\//gi)) {
      lang = "ch";
    } else if (curWwwPath.match(/\/en\b|\/en\//gi)) {
      lang = "en";
    }
    // 构建新的 URL
    const newPath = `/${basename}/${lang === "ch" ? 'en' : 'ch'}`;
    // 重定向到新的 URL
    window.location.href = window.origin + newPath;
  };

  const handleShoppingCart = () => {
    const language = getCurrentLang();
    const now = Date.now();
    const hours = now / 1000 / 60 / 60; // 注意这里的结果会是一个小数
    const hoursInt = Math.floor(hours);
    window.location.href = `${urlConstantJs.navURL}/shopping-cart/${language}/list?t=${hoursInt}`;
  };

  const handleJumpSuperAgent = () => {
    window.location.href = urlConstantJs.superAgentURL || '';
  };

  const handleLogout = () => {
    const lang = getCurrentLang();
    window.location.href = getLink(`/${lang}/Account/LogOff?returnURL=`) + getLink(`/${lang}/Home/Index`);
  };

    
    const lang = getCurrentLang();    
    const baseUrl = process.env.REACT_APP_TOKEN_API_BASE_URL;
    const breadcrumbData = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
            {
                "@type": "ListItem",
                "position": 1,
                "name": (lang === "ch") ? "首頁" : "Home",
                "item": (lang === "ch")
                    ? `${baseUrl}/ch/Home/Index`
                    : `${baseUrl}/en/Home/Index`
            },
            {
                "@type": "ListItem",
                "position": 2,
                "name": (lang === "ch") ? "預先評估服務" : "Pre-assessment Service",
                "item": (lang === "ch")
                    ? `${baseUrl}/pre-assessment-service/ch`
                    : `${baseUrl}/pre-assessment-service/en`
                                    
            }
        ]
    };

    const FAQData = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
            {
                "@type": "Question",                
                "name": (lang === "ch")
                ? "哪些受保人可以申請預先評估服務？"
                : "Who is eligible to apply for the Pre-Assessment Service?",
                "acceptedAnswer": {
                    "@type": "Answer",                  
                    "text": (lang === "ch")
                    ? "持有藍十字團體醫療或個人醫療保險的合資格受保人，並符合保單條款及申請要求，均可申請預先評估服務。"
                    : "Eligible insured persons who hold Blue Cross Group Medical Insurance or Individual Medical Insurance, and who meet the policy terms and application requirements, may apply for the Pre-Assessment Service."
                }
            },
            {
                "@type": "Question",                
                "name": (lang === "ch")
                    ? "預先批核是否等同最終賠償金額？"
                    : "Is the pre-approval amount the same as the final claim amount?",
                "acceptedAnswer": {
                    "@type": "Answer",                    
                    "text": (lang === "ch")
                        ? "不是。預先批核或賠償估算只供參考，實際賠償金額須以最終理賠審核結果為準，並須符合保單條款及細則。"
                        : "No. The pre-approval or estimated claim amount is for reference only. The actual reimbursement amount is subject to the final claims assessment and must comply with the policy terms and conditions."
                }
            },
            {
                "@type": "Question",                
                "name": (lang === "ch")
                    ? "免找數服務是否適用於所有醫院？"
                    : "Is the Cashless Service applicable to all hospitals?",
                "acceptedAnswer": {
                    "@type": "Answer",                    
                    "text": (lang === "ch")
                        ? "免找數服務只適用於指定本地私家醫院及合資格住院手術或治療，並須事先申請及獲批。"
                        : "The Cashless Service is only applicable to designated local private hospitals and eligible inpatient surgeries or treatments, and prior application and approval are required."
                }
            },
            {
                "@type": "Question",                
                "name": (lang === "ch")
                    ? "如實際醫療費用高於預估金額，應如何處理？"
                    : "What should I do if the actual medical expenses exceed the estimated amount?",
                "acceptedAnswer": {
                    "@type": "Answer",                    
                    "text": (lang === "ch")
                        ? "如實際醫療費用超出預先批核或估算金額，差額需由受保人自行支付，並可按保單條款向藍十字提出後續索償。"
                        : "If the actual medical expenses exceed the pre-approved or estimated amount, the insured person is required to settle the shortfall. Subsequent claims may be submitted to Blue Cross in accordance with the policy terms and conditions."
                }
            }
        ]

    };
    
  useEffect(() => {
    getUser();
    getHFMenu();
          
      var el = document.createElement('script');
      el.type = 'application/ld+json';
      el.text = JSON.stringify(breadcrumbData);
      document.querySelector('head').appendChild(el);

      var el_faq = document.createElement('script');
      el_faq.type = 'application/ld+json';      
      el_faq.text = JSON.stringify(FAQData);
      document.querySelector('head').appendChild(el_faq);           

    window.addEventListener("popstate", function (event) {
      window.history.pushState(null, null, document.URL);
      event.preventDefault();
      event.stopPropagation();
    });
  }, []);

  const linkRef = useRef([]);

  useEffect(() => {
    function changeAhref() {
      linkRef.current = Array.from(document.querySelectorAll("a"));

      linkRef.current.forEach((link) => {
        if (link.attributes['data-tag'] && link.attributes['data-tag'].value === 'pdf') {
          link.addEventListener("click", (event) => {

            event.preventDefault();
            let path = link.href;
            var r = Math.random() + '';
            r = r * 1000000;
            if (path.indexOf("?") == -1) {
              path += "?r=" + r;
            } else {
              path += "&r=" + r;
            }

            //path += "&bluecrossaction=PDF#page=1&view=Fit&toolbar=1";
            path += "&bluecrossaction=OpenUrlEx";
            console.log("herf:", path);
            window.open(path);
          });
        }
      });

      // 返回一个清理函数，用于在组件卸载时移除监听器
      return () => {
        linkRef.current.forEach((link) => {
          if (link.attributes['data-tag'] && link.attributes['data-tag'].value === 'pdf') {
            link.removeEventListener("click", handleClick);
          }
        });
      };
    }


    // 在组件挂载后执行
    const handleClick = changeAhref();

    return handleClick;
  }, []); // 空依赖数组意味着仅在挂载时执行一次
  // Added by BX Howard for Homepage header and footer [End]

  // useEffect(() => { document.title = t("translation:home.document_title") }, [i18n.language]);

    
    const gotoSection1 = () => {
        let currentSection = "section1";
        console.log('gc: ' + currentSection);
        setCurrentSection(currentSection);
    section1Ref.current.scrollIntoView({ behavior: 'smooth' });
  };

  const gotoSection2 = () => {
    section2Ref.current.scrollIntoView({ behavior: 'smooth' });
  };

  const gotoSection3 = () => {
    section3Ref.current.scrollIntoView({ behavior: 'smooth' });
  };

  const gotoSection5 = () => {
    section5Ref.current.scrollIntoView({ behavior: 'smooth' });
  };

    const gotoSection7 = () => {
        let currentSection = "section7";        
        setCurrentSection(currentSection);
        section7Ref.current.scrollIntoView({ behavior: 'smooth' });
    };

    const gotoSection6 = () => {
        let currentSection = "section6";
        
        setCurrentSection(currentSection);
        section6Ref.current.scrollIntoView({ behavior: 'smooth' });
    };

    

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsSubBarSticky(!entry.isIntersecting);
      }
    );
    if (subNavBarRef.current) {
      observer.observe(subNavBarRef.current);
    }
    return () => {
      observer.disconnect();
    };
  }, []);

    useEffect(() => {
                
    const observer = new IntersectionObserver(
      (entries) => {
            entries.forEach((entry) => {                               
          if (entry.isIntersecting) {            
              /*setCurrentSection(entry.target.id);*/
                //console.log(entry.target.id);                
          }
        });
      },
      { threshold: 0.7 } // Adjust this value as needed
    );

    observer.observe(section1Ref.current);
    // observer.observe(section2Ref.current);
    observer.observe(section5Ref.current);
    observer.observe(section7Ref.current);
    observer.observe(section6Ref.current);
    

    return () => {
      observer.disconnect();
    };
  }, []);
  // 打开pdf阅读器。
  // const [isModalOpen, setIsModalOpen] = useState(false);
  // const [source] = useState(
  //   `${process.env.PUBLIC_URL}/doc/Pre-Auth_User_Guide_${i18n.language === "ch" ? "TC" : "EN"}_output.pdf`
  // );
  // const openModal = useCallback(() => {
  //   setIsModalOpen(true); 
  //   document.title='PCA User Guide'
  // }, []);
  // const closeModal = useCallback(() => {
  //   setIsModalOpen(false);
  //   document.title=t("translation:home.document_title")
  // }, []);


  const items = [
    {
      key: '1',
      label: <Flex>
        <FormTitle style={{ textAlign: "left" }}>{t('translation:home.section6.q1_title')}</FormTitle>
      </Flex>,
      children: <Flex direction={"column"} gap={16} alignItems={"flex-start"}>
        <FormText style={{ textAlign: "left" }}>{t('translation:home.section6.q1_content1')}</FormText>
      </Flex>,
    },
    {
      key: '2',
      label: <Flex>
        <FormTitle style={{ textAlign: "left" }}>{t('translation:home.section6.q2_title')}</FormTitle>
      </Flex>,
      children: <Flex direction={"column"} gap={16} alignItems={"flex-start"}>
        <FormText style={{ textAlign: "left" }}>{t('translation:home.section6.q2_content1')}</FormText>
      </Flex>,
    },
    {
      key: '3',
      label: <Flex>
        <FormTitle style={{ textAlign: "left" }}>{t('translation:home.section6.q3_title')}</FormTitle>
      </Flex>,
      children: <Flex direction={"column"} gap={16} alignItems={"flex-start"}>
        <FormText style={{ textAlign: "left" }}>{t('translation:home.section6.q3_content1')}</FormText>
      </Flex>,
    },
    {
      key: '4',
      label: <Flex>
        <FormTitle style={{ textAlign: "left" }}>{t('translation:home.section6.q4_title')}</FormTitle>
      </Flex>,
      children: <Flex direction={"column"} gap={16} alignItems={"flex-start"}>
        <FormText style={{ textAlign: "left" }}>{t('translation:home.section6.q4_content1')}</FormText>
      </Flex>,
    },
    {
      key: '5',
      label: <Flex>
        <FormTitle style={{ textAlign: "left" }}>{t('translation:home.section6.q5_title')}</FormTitle>
      </Flex>,
      children: <Flex direction={"column"} gap={16} alignItems={"flex-start"}>
        <FormText style={{ textAlign: "left" }}>{t('translation:home.section6.q5_content1')}</FormText>
      </Flex>,
    },
    {
      key: '6',
      label: <Flex>
        <FormTitle style={{ textAlign: "left" }}>{t('translation:home.section6.q6_title')}</FormTitle>
      </Flex>,
      children: <Flex direction={"column"} gap={16} alignItems={"flex-start"}>
        <FormText style={{ textAlign: "left" }}>{t('translation:home.section6.q6_content1')}</FormText>
        <FormText style={{ textAlign: "left" }}>{t('translation:home.section6.q6_content2')}</FormText>
      </Flex>,
    },
    {
      key: '7',
      label: <Flex>
        <FormTitle style={{ textAlign: "left" }}>{t('translation:home.section6.q7_title')}</FormTitle>
      </Flex>,
      children: <Flex direction={"column"} gap={16} alignItems={"flex-start"}>
        <FormText style={{ textAlign: "left" }}>{t('translation:home.section6.q7_content1')}</FormText>
      </Flex>,
    },
    {
      key: '8',
      label: <Flex>
        <FormTitle style={{ textAlign: "left" }}>{t('translation:home.section6.q8_title')}</FormTitle>
      </Flex>,
      children: <Flex direction={"column"} gap={16} alignItems={"flex-start"}>
        <FormText style={{ textAlign: "left" }}>{t('translation:home.section6.q8_content1')}</FormText>
      </Flex>,
    },
    {
      key: '9',
      label: <Flex>
        <FormTitle id="Q9title" style={{ textAlign: "left" }}>{t('translation:home.section6.q9_title')}</FormTitle>
      </Flex>,
      children: <Flex direction={"column"} gap={16} alignItems={"flex-start"}>
        <FormText style={{ textAlign: "left" }}>{t('translation:home.section6.q9_content1')}</FormText>
      </Flex>,
    },
    {
      key: '10',
      label: <Flex>
        <FormTitle style={{ textAlign: "left" }}>{t('translation:home.section6.q10_title')}</FormTitle>
      </Flex>,
      children: <Flex direction={"column"} gap={16} alignItems={"flex-start"}>
        <FormText style={{ textAlign: "left" }}>
          <Trans i18nKey="translation:home.section6.q10_content1" components={{ a: <a href={`${process.env.REACT_APP_PDF_PREFIX}/${i18n.language === "ch" ? "Pre-Auth_User_Guide_TC_output.pdf" : "Pre-Auth_User_Guide_EN_output.pdf"}`} target="_blank" style={{ "textDecoration": "underline" }} rel="nofollow" /> }} />
          {/* <Trans i18nKey="translation:home.section6.q10_content1" components={{ a: <a onClick={openModal} target="_blank" style={{ "textDecoration": "underline" }} rel="nofollow" /> }} /> */}
        </FormText>
      </Flex>,
    },
  ];

    
    const url_chi = `${process.env.REACT_APP_TOKEN_API_BASE_URL}/ch/Home/Index`;
    const url_eng = `${process.env.REACT_APP_TOKEN_API_BASE_URL}/en/Home/Index`;
    const url_serv_chi = `${process.env.REACT_APP_TOKEN_API_BASE_URL}/pre-assessment-service/ch`;
    const url_serv_eng = `${process.env.REACT_APP_TOKEN_API_BASE_URL}/pre-assessment-service/en`;
        

  const SubNavBarEle = ({ portal, isSubBarSticky }) => {
    if(!subNavBarRoot){
      return
    } 
     if (portal && isSubBarSticky) {
      return (
        <>
          {
            ReactDOM.createPortal(
              <SubNavBar $isSticky={isSubBarSticky}>
                    {                      
                    isPadView ?
                    <SubNavBarContent>
                      <SubNavBarContentLeft>
                        <SubNavBarButton onClick={gotoSection1} $isActive={currentSection === 'section1'}>{t('translation:home.subNavBar.section1Name')}</SubNavBarButton>
                        <SubNavBarButton onClick={gotoSection7} $isActive={currentSection === 'section7'}>{t('translation:home.subNavBar.section7Name')}</SubNavBarButton>
                        <SubNavBarButton onClick={gotoSection6} $isActive={currentSection === 'section6'}>{t('translation:home.subNavBar.section3Name')}</SubNavBarButton>
                        {/* <SubNavBarButton onClick={gotoSection3} $isActive={currentSection === 'section3'}>{t('translation:home.subNavBar.section3Name')}</SubNavBarButton> */}
                      </SubNavBarContentLeft>
                      <SubNavBarContentRight>
                        <FormButtonDanger id={isProduction ? "pre_auth_learn_apply_btn_2" : "pre_auth_uat_learn_apply_btn_2"} style={{ padding: "5px 30px", marginBottom: 5 }} onClick={() => {
                          setStep("0");
                          navigate(`/${basename}/${i18n.language}/apply`);
                        }}>{t('translation:home.subNavBar.btn')}</FormButtonDanger>
                      </SubNavBarContentRight>
                    </SubNavBarContent>
                    :                    
                    <SubNavBarContent>
                       <SubNavBarContentLeft>                        
                        <SubNavBarImg src={`${process.env.PUBLIC_URL}/images/product_medical.png`} alt="icon" />
                        <SubNavBarText style={{ margin: "0px 8px 0px 15px", paddingRight: 15, borderRight: "1px solid var(--aia-bx-medium-blue-20)" }}>{t('translation:home.subNavBar.service')}</SubNavBarText>
                        <SubNavBarText>{t('translation:home.subNavBar.serviceName')}</SubNavBarText>
                      </SubNavBarContentLeft>
                      <SubNavBarContentRight>
                        <SubNavBarButton onClick={gotoSection1} $isActive={currentSection === 'section1'}>{t('translation:home.subNavBar.section1Name')}</SubNavBarButton>
                        <SubNavBarButton onClick={gotoSection7} $isActive={currentSection === 'section7'}>{t('translation:home.subNavBar.section7Name')}</SubNavBarButton>
                        <SubNavBarButton onClick={gotoSection6} $isActive={currentSection === 'section6'}>{t('translation:home.subNavBar.section3Name')}</SubNavBarButton>
                                    
                        {/* <SubNavBarButton onClick={gotoSection3} $isActive={currentSection === 'section3'}>{t('translation:home.subNavBar.section3Name')}</SubNavBarButton> */}
                        <FormButtonDanger id={isProduction ? "pre_auth_learn_apply_btn_2" : "pre_auth_uat_learn_apply_btn_2"} style={{ padding: "5px 30px", marginBottom: 5 }} onClick={() => {
                          setStep("0");
                          navigate(`/${basename}/${i18n.language}/apply`);
                        }}>{t('translation:home.subNavBar.btn')}</FormButtonDanger>
                      </SubNavBarContentRight>
                    </SubNavBarContent>
                }
              </SubNavBar>,
              subNavBarRoot
            )
          }
        </>
      );
    }

      return (
        <>
        <SubNavBar $isSticky={!isSubBarSticky} style={{ borderBottom: 'none' }}>
        {         
                      <SubNavBarContent>                       
                <SubNavBarContentLeft>                
                              <a style={{ textDecoration: 'none' }} href={curLang === 'en' ? url_eng : url_chi}>{t(`translation:home.intro.first`)}</a> >
                              <a style={{ textDecoration: 'none' }} href={curLang === 'en' ? url_serv_eng : url_serv_chi}>{t(`translation:home.intro.title`)}</a> 
              </SubNavBarContentLeft>
              <SubNavBarContentRight>               
                </SubNavBarContentRight>                        
            </SubNavBarContent>                    
            
        }
        </SubNavBar>

        <SubNavBar $isSticky={!isSubBarSticky}>
        {
          isPadView ?
            <SubNavBarContent>
              <SubNavBarContentLeft>
                <SubNavBarButton onClick={gotoSection1} $isActive={currentSection === 'section1'}>{t('translation:home.subNavBar.section1Name')}</SubNavBarButton>
                <SubNavBarButton onClick={gotoSection7} $isActive={currentSection === 'section7'}>{t('translation:home.subNavBar.section7Name')}</SubNavBarButton>
                <SubNavBarButton onClick={gotoSection6} $isActive={currentSection === 'section6'}>{t('translation:home.subNavBar.section3Name')}</SubNavBarButton>
                {/* <SubNavBarButton onClick={gotoSection3} $isActive={currentSection === 'section3'}>{t('translation:home.subNavBar.section3Name')}</SubNavBarButton> */}
              </SubNavBarContentLeft>
              <SubNavBarContentRight>
                <FormButtonDanger id={isProduction ? "pre_auth_learn_apply_btn_2" : "pre_auth_uat_learn_apply_btn_2"} style={{ padding: "5px 30px", marginBottom: 5 }} onClick={() => {
                  setStep("0");
                  navigate(`/${basename}/${i18n.language}/apply`);
                }}>{t('translation:home.subNavBar.btn')}</FormButtonDanger>
              </SubNavBarContentRight>
            </SubNavBarContent>
                    :                   
            <SubNavBarContent>                       
                <SubNavBarContentLeft>                
                <SubNavBarImg src={`${process.env.PUBLIC_URL}/images/product_medical.png`} alt="icon" />
                <SubNavBarText style={{ margin: "0px 8px 0px 15px", paddingRight: 15, borderRight: "1px solid var(--aia-bx-medium-blue-20)" }}>{t('translation:home.subNavBar.service')}</SubNavBarText>
                <SubNavBarText>{t('translation:home.subNavBar.serviceName')}</SubNavBarText>
              </SubNavBarContentLeft>
              <SubNavBarContentRight>
                <SubNavBarButton onClick={gotoSection1} $isActive={currentSection === 'section1'}>{t('translation:home.subNavBar.section1Name')}</SubNavBarButton>
                <SubNavBarButton onClick={gotoSection7} $isActive={currentSection === 'section7'}>{t('translation:home.subNavBar.section7Name')}</SubNavBarButton>
                <SubNavBarButton onClick={gotoSection6} $isActive={currentSection === 'section6'}>{t('translation:home.subNavBar.section3Name')}</SubNavBarButton>
                {/* <SubNavBarButton onClick={gotoSection3} $isActive={currentSection === 'section3'}>{t('translation:home.subNavBar.section3Name')}</SubNavBarButton> */}
                <FormButtonDanger id={isProduction ? "pre_auth_learn_apply_btn_2" : "pre_auth_uat_learn_apply_btn_2"} style={{ padding: "5px 30px", marginBottom: 5 }} onClick={() => {
                  setStep("0");
                  navigate(`/${basename}/${i18n.language}/apply`);
                }}>{t('translation:home.subNavBar.btn')}</FormButtonDanger>
                </SubNavBarContentRight>                        
            </SubNavBarContent>                                
        }
      </SubNavBar>
          </>
    )
  };

  const subNavBarRoot = document.querySelector('.is-fixed');
  const [isHeaderReady, setIsHeaderReady] = useState(false);
  useEffect(() => {
    setIsHeaderReady(true);
  }, []);

  const curLang = getCurrentLang();
  const [bannerImage, setBannerImage] = useState({
    language: 'TC',
    device: 'desktop'
  });
  const windowWidth = useWindowSize();
  useEffect(() => {
    const lang = curLang === 'en' ? 'EN' : "TC";
    if (windowWidth > 750 && windowWidth <= 1024) {
      setBannerImage({
        language: lang,
        device: 'ipad'
      });
    } else if (windowWidth <= 750) {
      setBannerImage({
        language: lang,
        device: 'mobile'
      });
    } else {
      setBannerImage({
        language: lang,
        device: 'desktop'
      });
    }
  }, [curLang, windowWidth]);
  const isHiddenHeader = isMobileAPPHiddenHeader();

  const hiddenClassNames = classNames('bx-home-header', {
    'hideHeader-page': isHiddenHeader,
  });
  const [cartNum, setCartNum] = useState(0);
  /**
 * 为了兼容mobile app Android 上无法打开new tab 的问题
 * 为了处理 pdf 无法再 Android 上面打开的问题
 * @param url pdf url or new tab url
 */
  const openUrlEx = (url) => {
    let path = url;
    let r = Math.random() + '';
    r = r * 1000000;
    if (path.indexOf('?') == -1) {
      path += '?r=' + r;
    } else {
      path += '&r=' + r;
    }
    //path += "&bluecrossaction=PDF#page=1&view=Fit&toolbar=1";
    path += '&bluecrossaction=OpenUrlEx';
    // console.log('bluecrossaction href:', path);
    window.open(path);
  };

  const handleLiClick = (item) => {
    // 还根据数据来判定不同的行为
    // if (item && item.value === '1-2') {
    Dialog({
      id: `dialog-${item?.ItemId}`,
      closeOpen: false,
      classNames: { all: 'iron-cp-dialog-box' },
      children: (
        <div className="iron-cp-dialog">
          <h3 className="iron-cp-dialog-title">{t('common:header.cpDialogTitle')}</h3>
          <img
            className="iron-cp-dialog-img"
            src={`${process.env.PUBLIC_URL}/images/cpModalImage.webp`}
            alt={t('common:header.cpDialogTitle')}
          />
          <span
            className="iron-cp-dialog-desc"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: t('common:header.cpDialogDesc'),
            }}
          />
          {/* 在项目里面使用的时候，建议使用环境变量去拼接 */}
        </div>
      ),
      cancelTxt: (
        <a
          className="iron-cp-dialog-skip"
          onClick={() => {
            openUrlEx(getLink(item?.ActionValue));
          }}
          target={item?.Target}
          id={`a-${item?.ItemId}-next`}
        >
          {t('common:header.cpDialogGoSuperCare')}
        </a>
      ),
      okTxt: (
        <a
          className="iron-cp-dialog-login"
          href={getLink(t('common:header.cpLink'))}
          target="_self"
          id="a-cplogin-next"
        >
          {t('common:header.cpDialogGoCP')}
        </a>
      ),
    });
    // }
  };

  return (
    <>
      <HeaderPlus
        className={hiddenClassNames}
        cartNum={cartNum}
        lang={curLang}
        data={rawHeader || []}
        headerTabs={curLang === 'en' ? headerTabsEN : headerTabs}
        onLiClick={handleLiClick}
        logoutText={loginFlag ? t('translation:home.header.logout') : ''}
        onLogout={handleLogout}
        headerTop={{
          superAgentText: 'Super Agent',
          langText: t('translation:home.header.lang'),
          onChangeLang: handleChangeLanguage,
          onShoppingCart: handleShoppingCart,
          onSuperAgent: handleJumpSuperAgent,
        }}
        logoBackConfig={{
          ActionValue: '/',
          AssetList: [
            {
              Channel: 'DESKTOP',
              WebPath:
                'https://www.bluecross.com.hk/images/CorporateWebsite/Header/BlueCrossLogo.webp',
              Alt: 'BlueCross Logo',
            },
            {
              Channel: 'MOBILE',
              WebPath:
                'https://www.bluecross.com.hk/images/CorporateWebsite/Header/BlueCrossLogo.webp',
              Alt: 'BlueCross Logo',
            },
          ],
        }}
      />

      <BackgroundImage className="bx-home-hero hideHeader-bg">
        <BackgroundImageContent>
          <BackgroundImageContentLeft>
            {/* <SubTitle>{t("translation:home.info.subtitle1")}</SubTitle> */}
            <Title style={{ fontSize: i18n.language === "en" ? 29 : 47 }}>{t("translation:home.info.title1")}</Title>
            <Title style={{ fontSize: i18n.language === "en" ? 29 : 47 }}>{t("translation:home.info.title2")}</Title>
            {/* <SubTitle style={{ textAlign: "right", paddingRight: 100 }}>{t("translation:home.info.subtitle2")}</SubTitle> */}
          </BackgroundImageContentLeft>
          <BackgroundImageContentRight style={{ gap: i18n.language === "en" ? 8 : 16 }}>
            <FormHeader style={{ margin: 0, fontSize: i18n.language === "en" ? 23 : 28 }}>{t('translation:home.intro.title')}</FormHeader>
            <HomeText style={{ fontSize: 14 }}>{t('translation:home.intro.desc1')}</HomeText>
            <FormButtonDanger id={isProduction ? "pre_auth_learn_apply_btn_1" : "pre_auth_uat_learn_apply_btn_1"} style={{ width: "100%" }} onClick={() => {
              setStep("0");
              navigate(`/${basename}/${i18n.language}/apply`);
            }}>{t('translation:home.intro.applyBtn')}</FormButtonDanger>
            <FormButtonSecondary id={isProduction ? "pre_auth_learn_progress_btn" : "pre_auth_uat_learn_progress_btn"} style={{ width: "100%" }} onClick={() => {
              navigate(`/${basename}/${i18n.language}/apply/progress`);
                      }}>{t('translation:home.intro.progressBtn')}</FormButtonSecondary>
                      <FormButtonSecondary id={isProduction ? "pre_auth_learn_progress_btn" : "pre_auth_uat_learn_progress_btn"} style={{ width: "100%" }} onClick={() => {
                          const url_chi = `${process.env.REACT_APP_PDF_PREFIX}/Pre-Auth_User_Guide_TC_output.pdf`;
                          const url_eng = `${process.env.REACT_APP_PDF_PREFIX}/Pre-Auth_User_Guide_EN_output.pdf`;
                          window.open(i18n.language === "en" ? url_eng : url_chi, '_self');              
                      }}>{t('translation:home.intro.userGuideBtn')}</FormButtonSecondary>
          </BackgroundImageContentRight>
        </BackgroundImageContent>
      </BackgroundImage>

          {/* <Breadcrumb /> */}


      <SubNavBarRefEle ref={subNavBarRef}></SubNavBarRefEle>
      <SubNavBarEle portal={isHeaderReady} isSubBarSticky={isSubBarSticky} />

      <Section1RefEle id="section1" ref={section1Ref} $isSticky={isSubBarSticky}></Section1RefEle>
      <Section1>
        <PreauthImageContainer>
          <PreauthImage src={`${process.env.PUBLIC_URL}/images/banner_pre_assessment_${bannerImage.device}_${bannerImage.language}.png`} />
        </PreauthImageContainer>
        {/*  */}
        <p className="text-align-left">
          {t('translation:home.section1.tnc')}
          <a onClick={() => {
            document.querySelector('#Q9title').scrollIntoView({
              behavior: "smooth",
              block: "start"// 替代 alignToTop: true
            })
          }}>{t('translation:home.section1.tncItem')}</a>
        </p>
        <Subtitle>{t('translation:home.section1.title')}</Subtitle>
        <Space height={24} />
        <HomeText>{t('translation:home.section1.subtitle')}</HomeText>
        <Space height={56} />
        <VideoWrapper>
          <video src={`${process.env.REACT_APP_PDF_PREFIX}/preauth promo_${getCurrentLang() === 'en' ? 'en' : 'tc'}.mp4`} controls width="100%" poster={`${process.env.PUBLIC_URL}/images/${getCurrentLang() === 'en' ? 'Cover-EN.png' : 'Cover-TC.png'}`}></video>
        </VideoWrapper>
        <Flex direction={isPadView ? "column" : "row"} justifyContent={"center"} alignItems={'stretch'} gap={32} style={{ rowGap: 16 }}>
          <Section1ShadowBox>
            <ImgCircle src={`${process.env.PUBLIC_URL}/images/ciS0fW.png`} alt={t('translation:home.section1.area1_title')} />
            <FormTitle style={{ fontSize: 20 }}>{t('translation:home.section1.area1_title')}</FormTitle>
            <HomeText>{t('translation:home.section1.area1_content')}</HomeText>
          </Section1ShadowBox>
          <Section1ShadowBox>
            <ImgCircle src={`${process.env.PUBLIC_URL}/images/jpYm7s.png`} alt={t('translation:home.section1.area1_title')} />
            <FormTitle style={{ fontSize: 20 }}>{t('translation:home.section1.area2_title')}</FormTitle>
            <HomeText>{t('translation:home.section1.area2_content')}</HomeText>
          </Section1ShadowBox>
          <Section1ShadowBox>
            <ImgCircle src={`${process.env.PUBLIC_URL}/images/Layer_1.png`} alt={t('translation:home.section1.area1_title')} />
            <FormTitle style={{ fontSize: 20 }}>{t('translation:home.section1.area3_title')}</FormTitle>
            <HomeText>
              <Trans
                i18nKey="translation:home.section1.area3_content"
                components={{ sup: <sup /> }}
              />
            </HomeText>
          </Section1ShadowBox>
        </Flex>
        <Space height={32} />
        <FormRemark style={{ textAlign: isPadView ? "center" : "left" }}>
          <Trans
            i18nKey="translation:home.section1.remark"
            components={{ sup: <sup /> }}
          />
        </FormRemark>

        <Space height={100} />
      </Section1>

      {/* <Section2RefEle id="section2" ref={section2Ref} $isSticky={isSubBarSticky}></Section2RefEle> */}
      <Section2>
        <Section2Content>

          <Subtitle>{t('translation:home.section2.title')}</Subtitle>
          <Space height={24} />
          <HomeText>
            <Trans
              i18nKey="translation:home.section2.subtitle"
              components={{ sup: <sup /> }}
            />
          </HomeText>

          <Space height={56} />

          <Flex direction={isPadView ? "column" : "row"} justifyContent={"center"} alignItems={'stretch'} gap={32} style={{ rowGap: 16, maxWidth: isPadView ? "initial" : 800 }}>
            <Section2ShadowBox>
              <Section2Img style={{ backgroundImage: `url("${process.env.PUBLIC_URL}/images/image 80.png")` }}>
                <Section2Tag>
                  <img src={`${process.env.PUBLIC_URL}/images/document-fold.png`} alt={t('translation:home.section2.area1_tag')} style={{ width: 19, height: 21 }} />
                  <HomeText style={{ color: "var(--aia-bx-white)", fontWeight: "bold" }}>{t('translation:home.section2.area1_tag')}</HomeText>
                </Section2Tag>
              </Section2Img>
              <Flex direction={"column"} alignItems={"flex-start"} style={{ padding: 24 }}>
                <FormTitle style={{ fontSize: 20, marginBottom: 16 }}>{t('translation:home.section2.area1_title')}</FormTitle>
                <HomeText style={{ textAlign: "left" }}>{t('translation:home.section2.area1_content')}</HomeText>
              </Flex>
            </Section2ShadowBox>
            <Section2ShadowBox>
              <Section2Img style={{ backgroundImage: `url("${process.env.PUBLIC_URL}/images/image 217.png")` }}>
                <Section2Tag>
                  <img src={`${process.env.PUBLIC_URL}/images/money-bag-white2.png`} alt={t('translation:home.section2.area2_tag')} style={{ width: 15, height: 20 }} />
                  <HomeText style={{ color: "var(--aia-bx-white)", fontWeight: "bold" }}>{t('translation:home.section2.area2_tag')}</HomeText>
                </Section2Tag>
              </Section2Img>
              <Flex direction={"column"} alignItems={"flex-start"} style={{ padding: 24 }}>
                <FormTitle style={{ fontSize: 20, marginBottom: 16 }}>{t('translation:home.section2.area2_title')}</FormTitle>
                <HomeText style={{ textAlign: "left" }}>{t('translation:home.section2.area2_content')}</HomeText>
              </Flex>
            </Section2ShadowBox>
          </Flex>

          <Space height={64} />
          <FormRemark style={{ textAlign: isPadView ? "center" : "left" }}>
            <Trans
              i18nKey="translation:home.section2.remark"
              components={{ sup: <sup /> }}
            />
          </FormRemark>

          <Space height={100} />

        </Section2Content>
      </Section2>

      {/* <Section3RefEle id="section3" ref={section3Ref} $isSticky={isSubBarSticky}></Section3RefEle> */}
      <Section3>
        <Section3Content>

          <Subtitle>{t('translation:home.section3.title')}</Subtitle>
          <Space height={24} />
          <HomeText>{t('translation:home.section3.subtitle')}</HomeText>

          <Space height={56} />

          <Flex direction={"column"} alignItems={"stretch"}>
            <Flex direction={"column"}>
              <Section3ShadowBox style={{ padding: isMobileView ? "24px 0px" : "24px 80px" }}>
                <StepImg src={`${process.env.PUBLIC_URL}/images/home_8.png`} alt="home img 8" />
                <Flex direction={"column"} alignItems={"flex-start"} gap={8} style={{ maxWidth: isMobileView ? "100%" : 400, padding: "0px 8px" }}>
                  <FormTitle style={{ textAlign: "left" }}>{t('translation:home.section3.area1_title')}</FormTitle>
                  <FormText style={{ textAlign: "left" }}>{t('translation:home.section3.area1_content')}</FormText>
                  <DownloadButton id={isProduction ? "pre_auth_learn_download_form_btn_1" : "pre_auth_uat_learn_download_form_btn_1"} onClick={() => {
                    const url = `${process.env.REACT_APP_PDF_PREFIX}/MC223_Pre-assessment Service (2024_1031).pdf`;
                    window.open(url, '_blank');
                  }}><DownloadButtonText>{t("translation:home.section3.area1_btn")}</DownloadButtonText></DownloadButton>
                </Flex>
              </Section3ShadowBox>
              <Down />
            </Flex>
            <Flex direction={"column"}>
              <Section3ShadowBox style={{ padding: isMobileView ? "24px 0px" : "24px 80px" }}>
                <StepImg src={`${process.env.PUBLIC_URL}/images/Group 48099812.png`} alt="home img 9" />
                <Flex direction={"column"} alignItems={"flex-start"} gap={8} style={{ maxWidth: isMobileView ? "100%" : 400, padding: "0px 8px" }}>
                  <FormTitle style={{ textAlign: "left" }}>{t('translation:home.section3.area2_title')}</FormTitle>
                  <FormText style={{ textAlign: "left" }}>{t('translation:home.section3.area2_content1')}</FormText>
                  <FormText style={{ textAlign: "left" }}>{t('translation:home.section3.area2_content2')}</FormText>
                </Flex>
              </Section3ShadowBox>
              <Down />
            </Flex>
            <Flex direction={"column"}>
              <Section3ShadowBox style={{ padding: isMobileView ? "24px 0px" : "24px 80px" }}>
                <StepImg src={`${process.env.PUBLIC_URL}/images/home_10.png`} alt="home img 10" />
                <Flex direction={"column"} alignItems={"flex-start"} gap={8} style={{ maxWidth: isMobileView ? "100%" : 400, padding: "0px 8px" }}>
                  <FormTitle style={{ textAlign: "left" }}>{t('translation:home.section3.area3_title')}</FormTitle>
                  <FormText style={{ textAlign: "left" }}>
                    <Trans
                      i18nKey="translation:home.section3.area3_content"
                      components={{ sup: <sup /> }}
                    />
                  </FormText>
                </Flex>
              </Section3ShadowBox>
              <Down />
            </Flex>
            <Flex direction={"column"}>
              <Section3ShadowBox style={{ padding: isMobileView ? "24px 0px" : "24px 80px" }}>
                <StepImg src={`${process.env.PUBLIC_URL}/images/home_11.png`} alt="home img 11" />
                <Flex direction={"column"} alignItems={"flex-start"} gap={8} style={{ maxWidth: isMobileView ? "100%" : 400, padding: "0px 8px" }}>
                  <Flex gap={8}>
                    <FormTitle style={{ textAlign: "left" }}>{t('translation:home.section3.area4_title')}</FormTitle>
                    <Tooltip title={t('translation:home.section3.area4_tip')}>
                      <InformationIcon style={{ cursor: "pointer" }}>i</InformationIcon>
                    </Tooltip>
                  </Flex>
                  <FormText style={{ textAlign: "left" }}>{t('translation:home.section3.area4_content1')}</FormText>
                  <FormText style={{ textAlign: "left" }}>{t('translation:home.section3.area4_content2')}</FormText>
                </Flex>
              </Section3ShadowBox>
            </Flex>
          </Flex>

          <Space height={64} />
          <FormRemark style={{ textAlign: isPadView ? "center" : "left" }}>
            <Trans
              i18nKey="translation:home.section3.remark"
              components={{ sup: <sup /> }}
            />
          </FormRemark>

          <Space height={100} />
        </Section3Content>
      </Section3>

      <Section4Container>
        <Section4>
          <Section4Content>
            <Subtitle>{t('translation:home.section4.title')}</Subtitle>

            <Space height={56} />

            <Flex direction={isPadView ? "column" : "row"} justifyContent={"center"} alignItems={'stretch'} gap={16}>
              <BackgroundImageFeature>
                <BackgroundImageFeatureIcon src={`${process.env.PUBLIC_URL}/images/product_gi.png`} alt={t('translation:home.section4.area1_title')} />
                <FormTitle style={{ fontSize: 20, color: "var(--aia-bx-white)" }}>{t('translation:home.section4.area1_title')}</FormTitle>
                <HomeText style={{ color: "var(--aia-bx-white)" }}>{t('translation:home.section4.area1_content')}</HomeText>
              </BackgroundImageFeature>
              <BackgroundImageFeature>
                <BackgroundImageFeatureIcon src={`${process.env.PUBLIC_URL}/images/home_4.png`} alt={t('translation:home.section4.area2_title')} />
                <Flex>
                  <FormTitle style={{ fontSize: 20, color: "var(--aia-bx-white)" }}>{t('translation:home.section4.area2_title')}</FormTitle>
                  <Tooltip title={t('translation:home.section4.area2_tip')}>
                    <InformationIcon style={{ cursor: "pointer", backgroundColor: "var(--aia-bx-white)", color: "#29B3E0" }}>i</InformationIcon>
                  </Tooltip>
                </Flex>
                <HomeText style={{ color: "var(--aia-bx-white)" }}>{t('translation:home.section4.area2_content')}</HomeText>
              </BackgroundImageFeature>
              <BackgroundImageFeature>
                <BackgroundImageFeatureIcon src={`${process.env.PUBLIC_URL}/images/product_medical3.png`} alt={t('translation:home.section4.area3_title')} />
                <FormTitle style={{ fontSize: 20, color: "var(--aia-bx-white)" }}>{t('translation:home.section4.area3_title')}</FormTitle>
                <HomeText style={{ color: "var(--aia-bx-white)" }}>{t('translation:home.section4.area3_content')}</HomeText>
              </BackgroundImageFeature>
              <BackgroundImageFeature>
                <BackgroundImageFeatureIcon src={`${process.env.PUBLIC_URL}/images/medical-bed2.png`} alt={t('translation:home.section4.area4_title')} />
                <FormTitle style={{ fontSize: 20, color: "var(--aia-bx-white)" }}>{t('translation:home.section4.area4_title')}</FormTitle>
                <HomeText style={{ color: "var(--aia-bx-white)" }}>{t('translation:home.section4.area4_content')}</HomeText>
              </BackgroundImageFeature>
            </Flex>

            <Space height={100} />

          </Section4Content>
        </Section4>
      </Section4Container>


      <Section5RefEle id="section5" ref={section5Ref} $isSticky={isSubBarSticky}></Section5RefEle>
      <Section5Container>
        <Section5>
          <Section5Content>
            <Subtitle style={{ color: "var(--aia-bx-white)" }}>{t('translation:home.section5.title')}</Subtitle>

            <Space height={56} />

            <Flex direction={isPadView ? "column" : "row"} justifyContent={"center"} alignItems={'stretch'} gap={16}>
              <Section5Case>
                <Flex width={"100%"} alignItems={"flex-start"}>
                  <Section5CaseInfo>
                    <FormTitle style={{ fontSize: 12, textAlign: "left" }}>{t('translation:home.section5.case1.line1')}</FormTitle>
                    <FormTitle style={{ fontSize: 24, textAlign: "left" }}>{t('translation:home.section5.case1.line2')}</FormTitle>
                    <FormText style={{ fontSize: 12, textAlign: "left" }}>{t('translation:home.section5.case1.line3')}</FormText>
                    <Space height={16} />
                    <FormTitle style={{ fontSize: 12, textAlign: "left" }}>{t('translation:home.section5.case1.line4')}</FormTitle>
                    <FormTitle style={{ fontSize: 24, textAlign: "left" }}>{t('translation:home.section5.case1.line5')}</FormTitle>
                    <FormText style={{ fontSize: 12, textAlign: "left" }}>{t('translation:home.section5.case1.line6')}</FormText>
                  </Section5CaseInfo>
                  <Section5CaseProfile>
                    <img src={`${process.env.PUBLIC_URL}/images/Hayden.png`} alt={"Hayden"} style={{ width: 120, height: 120 }} />
                    <FormTitle style={{ fontSize: 20 }}>Hayden</FormTitle>
                  </Section5CaseProfile>
                </Flex>
                <Flex style={{ padding: "8px 24px 24px 24px", alignSelf: "flex-start" }} direction={"column"} alignItems={"flex-start"} gap={16}>
                  <Flex gap={16}>
                    <Section5CaseStepNumber>1</Section5CaseStepNumber>
                    <FormText style={{ fontSize: 12, flex: 1, textAlign: "left", lineHeight: "18px" }}>{t('translation:home.section5.case1.step1')}</FormText>
                  </Flex>
                  <Flex gap={16}>
                    <Section5CaseStepNumber>2</Section5CaseStepNumber>
                    <FormText style={{ fontSize: 12, flex: 1, textAlign: "left", lineHeight: "18px" }}>{t('translation:home.section5.case1.step2')}</FormText>
                  </Flex>
                  <Flex gap={16}>
                    <Section5CaseStepNumber>3</Section5CaseStepNumber>
                    <FormText style={{ fontSize: 12, flex: 1, textAlign: "left", lineHeight: "18px" }}>{t('translation:home.section5.case1.step3')}</FormText>
                  </Flex>
                  <Flex gap={16} alignItems={"flex-start"}>
                    <Section5CaseStepNumber>4</Section5CaseStepNumber>
                    <FormText style={{ fontSize: 12, flex: 1, textAlign: "left", lineHeight: "18px" }}>{t('translation:home.section5.case1.step4')}</FormText>
                  </Flex>
                </Flex>
              </Section5Case>
              <Section5Case>
                <Flex width={"100%"} alignItems={"flex-start"}>
                  <Section5CaseInfo>
                    <FormTitle style={{ fontSize: 12, textAlign: "left" }}>{t('translation:home.section5.case2.line1')}</FormTitle>
                    <FormTitle style={{ fontSize: 24, textAlign: "left" }}>{t('translation:home.section5.case2.line2')}</FormTitle>
                    <FormText style={{ fontSize: 12, textAlign: "left" }}>{t('translation:home.section5.case2.line3')}</FormText>
                    <Space height={16} />
                    <FormTitle style={{ fontSize: 12, textAlign: "left" }}>{t('translation:home.section5.case2.line4')}</FormTitle>
                    <FormTitle style={{ fontSize: 24, textAlign: "left" }}>{t('translation:home.section5.case2.line5')}</FormTitle>
                    <FormText style={{ fontSize: 12, textAlign: "left" }}>{t('translation:home.section5.case2.line6')}</FormText>
                  </Section5CaseInfo>
                  <Section5CaseProfile>
                    <img src={`${process.env.PUBLIC_URL}/images/Jace.png`} alt={"Jace"} style={{ width: 120, height: 120 }} />
                    <FormTitle style={{ fontSize: 20 }}>Jace</FormTitle>
                  </Section5CaseProfile>
                </Flex>
                <Flex style={{ padding: "8px 24px 24px 24px", alignSelf: "flex-start" }} direction={"column"} alignItems={"flex-start"} gap={16}>
                  <Flex gap={16}>
                    <Section5CaseStepNumber>1</Section5CaseStepNumber>
                    <FormText style={{ fontSize: 12, flex: 1, textAlign: "left", lineHeight: "18px" }}>{t('translation:home.section5.case2.step1')}</FormText>
                  </Flex>
                  <Flex gap={16}>
                    <Section5CaseStepNumber>2</Section5CaseStepNumber>
                    <FormText style={{ fontSize: 12, flex: 1, textAlign: "left", lineHeight: "18px" }}>{t('translation:home.section5.case2.step2')}</FormText>
                  </Flex>
                  <Flex gap={16}>
                    <Section5CaseStepNumber>3</Section5CaseStepNumber>
                    <FormText style={{ fontSize: 12, flex: 1, textAlign: "left", lineHeight: "18px" }}>{t('translation:home.section5.case2.step3')}</FormText>
                  </Flex>
                  <Flex gap={16} alignItems={"flex-start"}>
                    <Section5CaseStepNumber>4</Section5CaseStepNumber>
                    <FormText style={{ fontSize: 12, flex: 1, textAlign: "left", lineHeight: "18px" }}>{t('translation:home.section5.case2.step4')}</FormText>
                  </Flex>
                </Flex>
              </Section5Case>
            </Flex>

            <Space height={100} />
          </Section5Content>
        </Section5>
      </Section5Container>

          <Section7RefEle id="section7" ref={section7Ref} $isSticky={isSubBarSticky}></Section7RefEle>
          <Section7Container>
          <Section7>
              <Section7Content style={{ width: isPadView ? "100%" : 300 }}>
                  <Subtitle style={{ color: "var(--aia-bx-dark-blue)" }}>{t('translation:home.section7.title')}</Subtitle>

                  <Space height={25} />

                  <DownloadButton id={isProduction ? "pre_auth_learn_download_form_btn_1" : "pre_auth_uat_learn_download_form_btn_1"} onClick={() => {
                      const url_chi = `${process.env.REACT_APP_PDF_PREFIX}/Pre-Auth_User_Guide_TC_output.pdf`;
                      const url_eng = `${process.env.REACT_APP_PDF_PREFIX}/Pre-Auth_User_Guide_EN_output.pdf`;
                      window.open(i18n.language === "en" ? url_eng : url_chi, '_blank');
                  }}><DownloadButtonText>{t("translation:home.section7.area1_btn")}</DownloadButtonText></DownloadButton>

                  <Space height={15} />

              </Section7Content>
              </Section7>
          </Section7Container>

      <Section6RefEle id="section6" ref={section6Ref} $isSticky={isSubBarSticky}></Section6RefEle>
      <Section6Container>
        <Section6>
          <Section6Content style={{ width: isPadView ? "100%" : 800 }}>
            <Subtitle style={{ color: "var(--aia-bx-dark-blue)" }}>{t('translation:home.section6.title')}</Subtitle>

            <Space height={56} />

            <Collapse
              expandIconPosition="end"
              style={{
                background: "var(--aia-bx-white)",
                width: isPadView ? "100%" : 800,
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.3)"
              }}
              items={items}
            />

            <Space height={100} />

          </Section6Content>
        </Section6>
      </Section6Container>
          
      
          
      {/* {isModalOpen && ( 
        <PDFReader source={source} isOpen={isModalOpen} onClose={closeModal}  className="aia-bx-pdfReader"/> 
       )} */}
      <PromotionRewards />
      {isMobileAPP() === false ? <FooterPlus
        data={raw}
        lang={curLang}
        logoBackConfig={{
          ActionValue: '/',
          AssetList: [
            {
              Channel: 'ALL',
              WebPath:
                'https://www.bluecross.com.hk/images/CorporateWebsite/Header/BlueCrossLogo.webp',
              Alt: 'BlueCross Logo',
            },
          ],
        }}
      /> : <></>}
    </>
  );
}

const BackgroundImage = styled.div`
  position: relative;
  margin-top: 0; 
  padding-top: 120px;
  height: 550px;
  width: 100%;
  background-image: url(${process.env.PUBLIC_URL}/images/home_background.png);
  background-size: cover;
  background-position: center;

  @media (max-width: 991px) {
    height: 700px;
    background-position: left;
  }
`;

const BackgroundImageContent = styled.div`
  display: flex;
  width: 80%;
  max-width: 1200px;
  justify-content: space-between;
  align-items: flex-end;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 50px;
  gap: 10px;
  
  @media (max-width: 991px) {
    align-items: flex-start;
    flex-direction: column;
    bottom: 20px;
    gap: 30px;
    max-width: none;
  }

  @media (max-width: 576px) {
    align-items: flex-start;
    flex-direction: column;
    bottom: 20px;
    gap: 50px;
    width: 95%;
  }
`;

const BackgroundImageContentLeft = styled.div`
  flex-shrink: 0;
  padding-top:120px;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 47px;
  color: var(--aia-bx-white);
  text-shadow: 1px 1px 2px grey, 0 0 1px grey, 0 0 0.2px grey;

  @media (max-width: 576px) {
    font-size: 44px;
  }
`;

const Section1ShadowBox = styled(ShadowBox)`
  flex-direction: column;
  padding: 24px;
`;

const ImgCircle = styled.img`
  width: 100px;
  height: 100px;
`;

const Section2ShadowBox = styled(ShadowBox)`
  width: 100%;
  flex-direction: column;
  padding: 0px;
  gap: 0px;
`;

const Section2Img = styled.div`
  width: 100%;
  height: 200px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  position: relative;
`;

const Section2Tag = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  background-color: var(--aia-bx-medium-blue-60);
  position: absolute;
  left: 0;
  top: 0;
  border-top-left-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 8px 16px;
  gap: 8px;
`;

const Down = styled(Flex)`
  background-image: url(${process.env.PUBLIC_URL}/images/down.png);
  width: 359px;
  height: 40px;
`;

const BackgroundImageContentRight = styled(ShadowBox)`
  max-width: 470px;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;

  @media (max-width: 991px) {
    max-width: none;
  }
`;

const SubNavBar = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 5px;
  background-color: var(--aia-bx-white);
  z-index: 9;
  ${props => props.$isSticky ? "display: flex;" : "display: none;"}
  border-bottom: 1px solid var(--aia-bx-medium-blue-20);
  transition: all .3s ease;
  -webkit-transition: all .3s ease;
  -moz-transform: all .3s ease;
`;

const SubNavBarRefEle = styled.div`
  position: relative;
  top: -80px;
  left: 0px;
`;

const Section1RefEle = styled.div`
  position: relative;
  ${props => props.$isSticky ? "top: -79px;" : "top: -129px;"}
  left: 0px;
`;

const Section2RefEle = styled.div`
  position: relative;
  ${props => props.$isSticky ? "top: -79px;" : "top: -129px;"}
  left: 0px;
`;

const Section3RefEle = styled.div`
  position: relative;
  ${props => props.$isSticky ? "top: -79px;" : "top: -129px;"}
  left: 0px;
`;

const Section5RefEle = styled.div`
  position: relative;
  ${props => props.$isSticky ? "top: -79px;" : "top: -129px;"}
  left: 0px;
`;

const Section7RefEle = styled.div`
  position: relative;
  ${props => props.$isSticky ? "top: -79px;" : "top: -129px;"}
  left: 0px;
`;

const Section6RefEle = styled.div`
  position: relative;
  ${props => props.$isSticky ? "top: -79px;" : "top: -129px;"}
  left: 0px;
`;


const SubNavBarContent = styled.div`
  width: 80%;
  max-width: 1200px;
  display: flex;
  justify-content: space-between;

  @media (max-width: 991px) {
    width: 95%;
    gap: 5px;
  }
`;

const SubNavBarContentLeft = styled.div`
  flex-shrink: 0;
  flex: 1;
  display: flex;
  align-items: center;
  padding-bottom: 5px;
  gap: 10px;

  @media (max-width: 991px) {
    padding-bottom: 0px;
    gap: 5px;
  }
`;

const SubNavBarImg = styled.img`
  width: 30px;
  height: 30px;
`;

const SubNavBarText = styled.div`
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--aia-bx-dark-blue);
`;

const SubNavBarContentRight = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 5px;
`;

const SubNavBarButton = styled.button`
  font-size: 0.875rem;
  color: var(--aia-bx-dark-blue);
  border: 0;
  background-color: transparent;
  cursor: pointer;
  padding: 10px 5px 13px;
  border-bottom: 2px solid transparent;

  transition: all .3s ease;
  -webkit-transition: all .3s ease;
  -moz-transform: all .3s ease;

  &:hover {
    border-bottom: 2px solid var(--aia-bx-dark-blue);
  }

  ${props => props.$isActive ? "font-weight: 700; border-bottom: 2px solid var(--aia-bx-dark-blue);" : ""}
`;

const Section1 = styled.section`
  width: 100%;
  max-width: 1000px;
  padding: 24px 8px 0;
  text-align: center;
`;

const DownloadButtonText = styled.div`
  font-size: 16px;
  line-height: 26px;
  color: var(--aia-bx-dark-blue);
`;

const DownloadButton = styled.button`
  border: 1px solid var(--aia-bx-blue-2);
  background-color: var(--aia-bx-white);
  border-radius: 50px;
  cursor: pointer;
  padding: 8px 40px;
  width: auto;
  
  &:hover {
  background-color: var(--aia-bx-blue-2);

    ${DownloadButtonText} {
    color: var(--aia-bx-white);
  }
}
`;

const Section2 = styled.section`
  width: 100%;
  padding: 120px 8px 0;
  background-color: var(--aia-bx-blue-5);
  border-top-right-radius: 120px;
  border-top-left-radius: 120px;

  @media (min-width: 576px) {
    display: flex;
    justify-content: center;
  }
`;

const Section2Content = styled.div`
  max-width: 1000px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Section3Container = styled.section`
  background-color: var(--aia-bx-blue-5);
  width: 100%;
`;

const Section3 = styled.section`
  width: 100%;
  padding: 120px 0px 0;
  background-color: var(--aia-bx-medium-blue-5);
  border-top-right-radius: 120px;
  border-top-left-radius: 120px;

  @media (min-width: 576px) {
    display: flex;
    justify-content: center;
  }
`;

const Section3Content = styled.div`
  max-width: 1000px;
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const Section3ShadowBox = styled(ShadowBox)`
  justify-content: center;
  gap: 8px;
  max-width: 95vw;
  background-color: var(--aia-bx-white);
`;

const Section4Container = styled.section`
  background-color: var(--aia-bx-medium-blue-5);
  width: 100%;
`;

const Section4 = styled.div`
  width: 100%;
  padding: 120px 8px 0;
  background-color: var(--aia-bx-blue-5);
  border-top-right-radius: 120px;
  border-top-left-radius: 120px;

  @media (min-width: 576px) {
    display: flex;
    justify-content: center;
  }
`;

const Section4Content = styled.div`
  max-width: 1000px;
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const Section5Container = styled.section`
  background-color: var(--aia-bx-blue-5);
  width: 100%;
`;

const Section5 = styled.div`
  width: 100%;
  padding: 120px 8px 0;
  background-color: var(--aia-bx-medium-blue-60);
  border-top-right-radius: 120px;
  border-top-left-radius: 120px;

  @media (min-width: 576px) {
    display: flex;
    justify-content: center;
  }
`;

const Section5Content = styled.div`
  max-width: 1000px;
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const Section5Case = styled(Flex)`
  background-color: var(--aia-bx-bright-blue-10);
  border-radius: 15px;
  gap: 0px;
  flex-direction: column;
  flex: 1;
  min-width:450px;
  
  @media (max-width: 768px) {
    min-width:unset;
    width:100%;;
  }
`;

const Section5CaseInfo = styled(Flex)`
  flex: 1;
  gap: 0px;
  padding: 32px 0px 32px 23px;
  flex-direction: column;
  align-items: flex-start;
`;

const Section5CaseProfile = styled(Flex)`
  flex: 1;
  flex-direction: column;
  background-image: url(${process.env.PUBLIC_URL}/images/product-learn_case-study_profile-bg.png);
  padding: 24px 16px;
  border-top-right-radius: 15px;
  border-bottom-left-radius: 30px;
`;

const Section5CaseStepNumber = styled(Flex)`
  background-color: var(--aia-bx-dark-blue);
  color: var(--aia-bx-white);
  width: 28px;
  height: 28px;
  border-radius: 28px;
  justify-content: center;
  align-items: center;
`;

const Section6Container = styled.section`
  background-color: var(--aia-bx-medium-blue-60);
  width: 100%;
`;

const Section6 = styled.div`
  width: 100%;
  padding: 120px 8px 0;
  background-color: var(--aia-bx-medium-blue-5);
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;

  @media (min-width: 576px) {
    display: flex;
    justify-content: center;
  }
`;

const Section6Content = styled.div`
  max-width: 1000px;
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const Section7Container = styled.section`
  background-color: var(--aia-bx-medium-blue-60);
  width: 100%;
`;

const Section7 = styled.div`
  width: 100%;
  padding: 120px 8px 0;
  background-color: var(--aia-bx-medium-blue-5);
  border-top-right-radius: 120px;
  border-top-left-radius: 120px;

  @media (min-width: 576px) {
    display: flex;
    justify-content: center;
  }
`;

const Section7Content = styled.div`
  max-width: 1000px;
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const Subtitle = styled.h2`
  font-size: 2rem;
  font-weight: 400;
  margin-bottom: 2rem;
  color: var(--aia-bx-dark-blue);
  font-weight: bold;
  margin: 0;
`;

const HomeText = styled(FormText)`
  font-size: 16px;
`;

const BackgroundImageFeature = styled.div`
  flex: 1;
  background-image: url(${process.env.PUBLIC_URL}/images/home_3.png);
  background-size: cover;
  background-position: center;
  border-radius: 20px;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const BackgroundImageFeatureIcon = styled.img`
  background-color: var(--aia-bx-white);
  border-radius: 50%;
  padding: 10px;
  width: 70px;
  height: 70px;
`;

const StepImg = styled.img`
  width: 85px;
  height: 85px;
`;
const PreauthImageContainer = styled.div`
  width: 100%;
} 
`
const PreauthImage = styled.img`
  width:100%;
  height:100%;
  object-fit:contain;
`;

const VideoWrapper = styled.div`
   margin-bottom:24px;
`;

export default PageHome;

